<div class="mandatory-criteria-dialog-container">
  <div class="mandatory-criteria-dialog-heading-container">
    <div class="mandatory-criteria-dialog-heading">
      Mandatory Criterion Not Met
    </div>
    <div class="mandatory-criteria-dialog-heading-closing">
      <img (click)="closeDialog()" src="/assets/images/close.svg" alt="close" />
    </div>
  </div>

  <div class="mandatory-criteria-dialog-main">
    <p>User doesn't met the mandatory Criterion.</p>
    <p>Please complete the following before submitting:</p>
    <ul>
      <li *ngFor="let item of unmetCriteria">{{ item }}</li>
    </ul>
  </div>

  <div class="mandatory-criteria-dialog-btn-container">
    <button class="btn-custom btn-primary-custom" (click)="closeDialog()">
      OK
    </button>
  </div>
</div>
